import { gql } from '@apollo/client'
import { SEGMENT_COMPLIANCE_GROUP_FRAGMENT } from './SegmentComplianceGroupFragment'
import { USER_FRAGMENT } from './UserFragment'

export const MODULAR_COMPLIANCE_AUDIT_FRAGMENT = gql`
  fragment ComplianceAudit on ComplianceAudit {
    id
    displayId
    dateCompleted
    saved
    strictScore
    sequenceScore
    employee {
      ...User
    }
    segmentCompliance {
      ...SegmentComplianceGroup
    }
  }
  ${SEGMENT_COMPLIANCE_GROUP_FRAGMENT}
  ${USER_FRAGMENT}
`
